// src/components/ClientList/AddClientModal.js
import React, { useState } from 'react';
import css from './AddClientModal.module.css';

const AddClientModal = ({ isOpen, onClose, onAddClient }) => {
  const [formData, setFormData] = useState({
    email: '',
    first_name: '',
    last_name: '',
    phone: '',
    date_of_birth: '',
    gender: '',
    notes: '',
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await onAddClient(formData);
    setLoading(false);
  };

  if (!isOpen) return null;

  return (
    <div className={css.overlay} onClick={onClose}>
      <div className={css.modal} onClick={(e) => e.stopPropagation()}>
        <div className={css.header}>
          <h2 className={css.title}>Add New Client</h2>
          <button className={css.closeButton} onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit} className={css.form}>
          <div className={css.formRow}>
            <div className={css.formGroup}>
              <label className={css.label}>
                First Name <span className={css.required}>*</span>
              </label>
              <input
                type="text"
                name="first_name"
                value={formData.first_name}
                onChange={handleChange}
                className={css.input}
                required
              />
            </div>

            <div className={css.formGroup}>
              <label className={css.label}>
                Last Name <span className={css.required}>*</span>
              </label>
              <input
                type="text"
                name="last_name"
                value={formData.last_name}
                onChange={handleChange}
                className={css.input}
                required
              />
            </div>
          </div>

          <div className={css.formGroup}>
            <label className={css.label}>
              Email <span className={css.required}>*</span>
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={css.input}
              required
            />
            <p className={css.helpText}>
              If this email exists in GymNet, they'll be marked as Active. Otherwise, they'll be a Prospect.
            </p>
          </div>

          <div className={css.formGroup}>
            <label className={css.label}>Phone</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className={css.input}
            />
          </div>

          <div className={css.formRow}>
            <div className={css.formGroup}>
              <label className={css.label}>Date of Birth</label>
              <input
                type="date"
                name="date_of_birth"
                value={formData.date_of_birth}
                onChange={handleChange}
                className={css.input}
              />
            </div>

            <div className={css.formGroup}>
              <label className={css.label}>Gender</label>
              <select
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                className={css.select}
              >
                <option value="">Select gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="non-binary">Non-binary</option>
                <option value="prefer-not-to-say">Prefer not to say</option>
              </select>
            </div>
          </div>

          <div className={css.formGroup}>
            <label className={css.label}>Notes</label>
            <textarea
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              className={css.textarea}
              rows={4}
              placeholder="Training goals, medical conditions, preferences, etc."
            />
          </div>

          <div className={css.actions}>
            <button
              type="button"
              onClick={onClose}
              className={css.btnSecondary}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={css.btnPrimary}
              disabled={loading}
            >
              {loading ? 'Adding...' : 'Add Client'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddClientModal;